import Web3 from "web3";
import { significantDigits,parseAmount,formatAmount,formatNumber } from '@/utils/format'
import { MaxUint256 } from '@ethersproject/constants';
// 初始化 Web3 实例，这里假设你已经有一个节点或提供商的 URL
const web3 = new Web3(window.ethereum);


const contractABIs = {
    erc20: require('@/assets/abi/erc20.json'),
    wallet:require('@/assets/abi/wallet.json'),
    // 其他合约类型可以在这里添加
};

async function getContractInstance(contractType, contractAddress) {
    try {
        // 从已加载的 ABI 中获取合约的 ABI
        const contractABI = contractABIs[contractType];

        if (!contractABI) {
            throw new Error(`未找到合约类型 ${contractType} 的 ABI`);
        }

        // 创建并返回合约实例
        const contractInstance = new web3.eth.Contract(contractABI, contractAddress);
        return contractInstance;
    } catch (error) {
        console.error(`获取合约实例失败: ${error.message}`);
        return null;
    }
}

async function getIstokenOne(abiPairContractAddress, tokenAddress) {
    const pairContract = await getContractInstance('pair', abiPairContractAddress);
    const token0Fun = pairContract.methods.token0;
    const res = await token0Fun().call();
    const token0 = res.toString();
    return token0.toLowerCase() === tokenAddress;
}
async function getOtherToken(abiPairContractAddress, tokenAddress) {
    const pairContract = await getContractInstance('pair', abiPairContractAddress);

    // 获取 token0 和 token1
    const token0Fun = pairContract.methods.token0;
    const token1Fun = pairContract.methods.token1;

    const res1 = await token0Fun().call();
    const res2 = await token1Fun().call();

    const token0 = res1.toString();
    const token1 = res2.toString();
    // 根据 tokenAddress 返回另一个 token
    if (token0 === tokenAddress) {
        return token1;
    } else {
        return token0;
    }
}



function switchEthereumChain(chainId) {
    return new Promise((resolve, reject) => {
        if (window.ethereum) {

            window.ethereum.request({ method: 'wallet_switchEthereumChain',params:[{chainId}] }).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                
                reject(error);
            });
        } else {
          
        }

    });
}

function requestWeb3ApplianceAccount() {
    return new Promise((resolve, reject) => {
        // 获取当前账户
        if (window.ethereum) {
            window.ethereum.request({ method: 'eth_requestAccounts' }).then(accounts => {
                resolve(accounts[0]);
            }).catch(error => {
                reject(error);
            });
        } else {
            reject('Please install MetaMask');
        }

    });
}

function accountsChangedWeb3Appliance() {
    return new Promise((resolve, reject) => {
        // 监听账户变化
        window.ethereum.on('accountsChanged', function (accounts) {
            resolve(accounts[0]);
        });
    });
}

async function getERC20TokenInfo(tokenAddress) {
    try {
        // 获取 ERC20 合约实例
        const erc20Contract = await getContractInstance('erc20', tokenAddress);

        if (!erc20Contract) {
            throw new Error('无法获取 ERC20 合约实例');
        }

        // 获取代币名称、符号、总供应量和精度
        const [name, symbol, totalSupply, decimals] = await Promise.all([
            erc20Contract.methods.name().call(),
            erc20Contract.methods.symbol().call(),
            erc20Contract.methods.totalSupply().call(),
            erc20Contract.methods.decimals().call(),
        ]);

        return {
            name,
            symbol,
            totalSupply: totalSupply.toString(), // 转换为字符串
            decimals: parseInt(decimals, 10),   // 转换为整数
        };
    } catch (error) {
        console.error('获取 ERC20 代币信息失败:', error.message);
        return null;
    }
}

async function getERC20TokenBalance(tokenAddress, userAddress, type = 2) {
    let balance = 0;
    let decimals = 18;
    try {

        if (type === 1) {
            balance = await web3.eth.getBalance(userAddress);
        } else if(type === 2){


            // 获取 ERC20 合约实例
            const erc20Contract = await getContractInstance('erc20', tokenAddress);

            if (!erc20Contract) {
                throw new Error('无法获取 ERC20 合约实例');

            }

            // 获取代币余额
             balance = await erc20Contract.methods.balanceOf(userAddress).call();
        }



        
        return formatNumber(formatAmount(balance),4) ;
    } catch (error) {
        console.error(`获取代币余额失败: ${error.message}`);
        return null;
    }
}

async function transferToken(type, senderAddress, recipientAddress, amount, tokenAddress = null) {
    return new Promise(async (resolve, reject) => {
        try {
            if (type === 1) {
                // ETH 转账逻辑
                const weiAmount = web3.utils.toWei(amount.toString(), 'ether');
                
                // 获取 gas 费用估算
                const gas = await web3.eth.estimateGas({
                    from: senderAddress,
                    to: recipientAddress,
                    value: weiAmount
                });

                // 获取当前账户的 gas price
                const gasPrice = await web3.eth.getGasPrice();

                // 执行 ETH 转账
                const transactionHash = await web3.eth.sendTransaction({
                    from: senderAddress,
                    to: recipientAddress,
                    value: weiAmount,
                    gas,
                    gasPrice
                });

                return resolve(transactionHash);
            } 
            else if (type === 2 && tokenAddress) {
                // ERC20 转账逻辑
                const erc20Contract = await getContractInstance('erc20', tokenAddress);

                if (!erc20Contract) {
                    return reject(new Error('无法获取 ERC20 合约实例'));
                }

                // 获取代币的精度
                const { decimals } = await getERC20TokenInfo(tokenAddress);

                if (decimals === null) {
                    return reject(new Error('无法获取代币精度'));
                }

                // 将 amount 转换为最小单位（根据精度）
                const bigIntAmount = BigInt(amount * (10 ** decimals));

                const gas = await erc20Contract.methods
                    .transfer(recipientAddress, bigIntAmount) // 使用最小单位
                    .estimateGas({ from: senderAddress });

                // 使用 Metamask 进行代币转账
                const transactionHash = await erc20Contract.methods
                    .transfer(recipientAddress, bigIntAmount.toString()) // 使用最小单位
                    .send({ from: senderAddress, gas });

                return resolve(transactionHash);
            } 
            else {
                return reject(new Error('无效的 type 或缺少 tokenAddress'));
            }
        } catch (error) {
            reject(error);  // 失败时返回错误
        }
    });
}


async function signMessage(message, fromAddress) {
    return new Promise(async (resolve, reject) => {
        try {
            const sign = await web3.eth.personal.sign(message, fromAddress, '');
            resolve(sign); // 返回签名
        } catch (error) {
            reject(error); // 失败时返回错误
        }
    });
}


async function isETHAddress(address) {
    return new Promise(async (resolve, reject) => {
        try {
            const isValid = await web3.utils.isAddress(address);
            console.log(isValid);

            resolve(isValid);
        } catch (error) {

            resolve(/^0x[a-fA-F0-9]{40}$/.test(address));
        }
    });
}

async function getAllowance(user_address, contract, tokenAddress) {
    return new Promise(async (resolve, reject) => {
        try {
            // 获取 ERC20 合约实例
            const erc20Contract = await getContractInstance('erc20', tokenAddress);
            const allowance = await erc20Contract.methods.allowance(user_address,contract).call();
            resolve(allowance);
        } catch (error) {
            console.error(`获取授权额度失败: ${error.message}`);
            reject(error);
        }
    });

}

async function setApproval(amount, contract, token, user_address) {
    return new Promise(async (resolve, reject) => {
        try {
            // 获取 ERC20 合约实例
            const erc20Contract = await getContractInstance('erc20', token);

            if (!erc20Contract) {
                throw new Error('无法获取 ERC20 合约实例');
            }
            const gas = await erc20Contract.methods
                .approve(contract, amount) // 使用最小单位
                .estimateGas({ from: user_address });
            // 调用 `approve` 方法设置授权
            const tx = await erc20Contract.methods.approve(contract, amount).send({ from: user_address, gas });
            resolve(tx);
        } catch (error) {
            console.error(`设置授权失败: ${error.message}`);
            reject(error);
        }

    })

}







export default {
    getContractInstance,
    requestWeb3ApplianceAccount,
    accountsChangedWeb3Appliance,
    getERC20TokenInfo,
    getERC20TokenBalance,
    transferToken,
    signMessage,
    isETHAddress,
    getAllowance,
    setApproval,
    switchEthereumChain,
}